import React, { useEffect, useMemo, useState } from 'react';
import Collapsible from './Collapsible';
import useBreakpoint, { BREAKPOINT_VAR_DESKTOP } from './../Hooks/useBreakpoint';

const FooterMenuColumnContents = (props) => {
  const { links, text } = props;

  return (
    <>
      <ul className="footer-menu-column__nav">
        {links.map((link) => (
          <li className="footer-menu-column__nav-item">
            <a className="footer-menu-column__nav-link" href={link.href}>
              {link.text}
            </a>
          </li>
        ))}
      </ul>
      {!!text && !!text.value && (
        <div
          className="footer-menu-column__text"
          dangerouslySetInnerHTML={{ __html: text.value }}
        ></div>
      )}
    </>
  );
};

const FooterMenuColumn = (props) => {
  const { id, title, links, text } = props;
  const breakpoint = useBreakpoint();
  const isDesktop = useMemo(() => breakpoint == BREAKPOINT_VAR_DESKTOP, [breakpoint]);
  const [isOpen, setIsOpen] = useState(false);
  const [content, setContent] = useState();

  useEffect(() => {
    setContent(<FooterMenuColumnContents {...props} />);
  }, [links, text]);

  const collapsiableOnChange = (value) => {
    setIsOpen(value);
  };

  return (
    <div className="footer-menu-column">
      {isDesktop ? (
        <>
          {!!title && <h2 className="footer-menu-column__title">{title}</h2>}
          {content}
        </>
      ) : (
        <Collapsible
          id={id}
          label={title}
          isOpen={isOpen}
          onChange={collapsiableOnChange}
          labelClassName="footer-menu-column__collapsible-title"
          arrowStyle={'white'}
        >
          <div className="footer-menu-column__collapsible-content">
            {content}
          </div>
        </Collapsible>
      )}
    </div>
  );
};

export default FooterMenuColumn;
